import {ContentBlocks_ImageTile as ImageTileType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/content_blocks.types';
import {
  ContentBlockImageTile,
  RowSection,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled as linariaStyled} from '@linaria/react';
import React from 'react';
import sc from 'styled-components';
import {useContentBlockPromotionTracking} from '../helpers/useContentBlockPromotionTracking';
import {useContentBlockPromotionTrackingImpression} from '../helpers/useContentBlockPromotionTrackingImpression';
import {alignmentMap, fontMap, styleMap, transformImage} from '../transforms';

export const ImageTile: React.FC<{
  content: ImageTileType;
  blockId?: number;
  testId?: string;
}> = ({content, blockId, testId = 'customPageImageTile'}) => {
  const {handleOnCTAClick, placementRef} = useTrackContentBlock(
    content,
    blockId,
  );

  return (
    <BlockWrapper
      $backgroundColor={content.backgroundColor}
      centerContent
      data-content-block={blockId}
      ref={placementRef}
    >
      <ContentWrapper>
        <ContentBlockImageTile
          testId={testId}
          image={transformImage(content.image)}
          content={{
            headlines: content.headline && {
              text: content.headline.text,
              color: content.headline.color,
              size: fontMap[content.headline.size],
              alignment: alignmentMap[content.headline.alignment],
            },
            ctas: content.cta && [
              {
                text: {
                  text: content.cta.text.text,
                  style: styleMap[content.cta.text.style],
                  textColor: content.cta.text.color,
                },
                link: content.cta.link,
              },
            ],
          }}
          onClickCTA={() => {
            if (content.cta) {
              // CTA position equals to 0 since imageTile can only have 1 CTA
              handleOnCTAClick(content.cta.text.text, content.cta.link, 0);
            }
          }}
        />
      </ContentWrapper>
    </BlockWrapper>
  );
};

const useTrackContentBlock = (content: ImageTileType, blockId?: number) => {
  const promotionTrackingClick = useContentBlockPromotionTracking();
  const locationBlockType = 'imageTile';

  const handleOnCTAClick = (
    promotionName: string,
    path: {url: string; external: boolean},
    ctaPosition: number,
  ) => {
    promotionTrackingClick({
      actionType: 'click',
      contentBlockSource: 'cta',
      locationBlockType,
      promotionId: blockId ? String(blockId) : '',
      blockId,
      promotionName,
      path,
      elementPosition: ctaPosition,
    });
  };

  const imageTileCTALink = (() => {
    if (content.cta) {
      return content.cta.link;
    }
    return {external: false, url: ''};
  })();

  const placementImpressionpromotionName = (() => {
    if (content.cta) {
      return content.cta.text.text;
    } else if (content.headline) {
      return content.headline.text;
    }
    return '';
  })();

  const {elementRef: placementRef} =
    useContentBlockPromotionTrackingImpression<HTMLDivElement>({
      blockId,
      promotionName: placementImpressionpromotionName,
      promotionId: blockId ? String(blockId) : '',
      locationBlockType,
      path: imageTileCTALink,
      contentBlockSource: 'banner',
    });

  return {
    handleOnCTAClick,
    placementRef,
  };
};

const BlockWrapper = linariaStyled(RowSection)<{$backgroundColor?: string}>`
  background-color: ${({$backgroundColor}) => $backgroundColor ?? ''};
  padding-bottom: 1rem;

  ${tabletAndUpLinaria('padding-bottom: 3rem;')};
`;

const ContentWrapper = sc.div`
  padding: 1rem;
  display: flex;
  flex-basis: 100%;
  max-width: 1440px;
`;
